import _ from "lodash";

import api from "@/api/cloud";
import { set } from "@/utils/vuex";

const getInitState = () => ({
	items: [],
	filter: null,
	groups: [],
	exclude: [
		undefined,
		"actions",
		"bridges",
		"steps",
		"conditions",
		"mobiles",
		"reminders",
		"scenes",
		"servers",
		"services",
		"systems",
		"triggers",
		"users",
	],
});

export default {
	namespaced: true,

	state: getInitState(),

	getters: {
		findByClass: state => cls => _.find(state.items, { cls }),

		filteredByGroup(state) {
			if (!state.filter) {
				return state.items;
			} else {
				const filter = state.filter.toLowerCase();
				return state.items.filter(item => {
					if (item.group) {
						const group = item.group.toLowerCase();
						return group.indexOf(filter) > -1;
					}
				});
			}
		},
		groups(state) {
			return state.groups;
		},
	},

	mutations: {
		setDescriptions: set("items"),
		setFilter: set("filter"),
		setGroups: set("groups"),

		resetState(state) {
			Object.assign(state, getInitState());
		},
	},

	actions: {
		async load({ commit, state }) {
			try {
				const descriptions = await api.getDescriptions();
				let items = [];
				for (let i in descriptions) {
					let description = descriptions[i];

					items.push({
						cls: i,
						name: description.meta.description,
						group: description.meta.group,
						data: description,
					});
				}

				let groupNames = _.difference(
					_.uniq(_.map(items, "group")),
					state.exclude
				).sort();

				let groups = _.map(groupNames, function(name) {
					return { value: name, text: _.startCase(_.toLower(name)) };
				});

				commit("setDescriptions", items);
				commit("setGroups", groups);
			} catch (e) {
				commit("setDescriptions", []);
				commit("setGroups", []);
				throw e;
			}
		},
		filter({ commit }, word) {
			commit("setFilter", word);
		},
	},
};
